<ng-container *msShowInEpcot="false">
    @if (isExtended) {
        <div class="betslip-edit-bet-notification-extended theme-error-i">
            <div class="betslip-edit-bet-notification-extended_container">
                <h4>{{ notification.title }}</h4>
                <p>{{ notification.message }}</p>
            </div>
        </div>
    } @else {
        <div class="betslip-edit-bet-notification">
            <div class="linkbox betslip-edit-bet-notification_container">
                <div class="betslip-edit-bet-notification_message">{{ notification.message }}</div>
            </div>
        </div>
    }
</ng-container>
<ng-container *msShowInEpcot="true">
    <ms-epcot-notification [message]="notification.message" [notificationHeaderTitle]="notification.title" [notificationType]="'info'" />
</ng-container>
